<template>
	<div v-scroll="{enabled: props.hideOnScroll, handler: handleScroll}" class="container-fab">
		<transition name="slide-bottom-transition">
			<btn-group v-if="props.visible && isActive">
				<slot/>
			</btn-group>
		</transition>
	</div>
</template>

<script setup lang="ts">
import {ToggleableComponentEmits, type ToggleableComponentProps} from "../../types";
import {useToggleableComponent} from "../../composables/useToggleableComponent";

const props = withDefaults(defineProps<{
	// Controls whether the component is currently shown
	modelValue?: boolean,

	// Might be used to force hiding the component when set to false even if modelValue is true
	visible?: boolean,

	// Whether to hide the component when scrolling down the page
	hideOnScroll?: boolean,
} & ToggleableComponentProps>(), {
	modelValue: true,
	visible: true,
});

const emit = defineEmits(ToggleableComponentEmits);

const {isActive} = useToggleableComponent(props, emit);

let scrollPosition = 0;

function handleScroll() {
	const currentScrollPosition = (typeof window !== 'undefined' ? window.scrollY : 0) as number;
	const scrollingUp = currentScrollPosition < scrollPosition;
	isActive.value = (currentScrollPosition < 150 || scrollingUp);
	scrollPosition = currentScrollPosition;
}

</script>

<style>
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.app .container-fab {
  position: fixed;
  margin-left: 1200px;
  margin-bottom: 16px;
  z-index: 50;
  bottom: 0;
}
@media (max-width: 1600px) {
  .app .container-fab {
    margin-left: 0;
    right: 16px;
  }
}
@media (max-width: 767px) {
  .app .container-fab {
    right: 8px;
  }
}

.has-mobile-bottom-bar .app .container-fab {
  margin-bottom: 60px;
}
</style>
